// Le bouton pilule du produit : primaire (encre), contour (blanc bordé),
// danger (rouge, réservé au bloquant), et inactif (crème, avec l'explication
// du pourquoi en title quand elle existe). Icône optionnelle ; un bouton à
// icône seule porte un aria-label.

import "./bouton.css";

import type { ComptaIconeNom } from "@app/components/compta/ui/ComptaIcone";
import { ComptaIcone } from "@app/components/compta/ui/ComptaIcone";
import type { ButtonHTMLAttributes } from "react";

export type VarianteBouton = "primaire" | "contour" | "danger" | "inactif";

// Le bouton d'une rangée dense (ligne de table, en-tête de section) est plus
// petit que celui d'un pied de panneau.
export type TailleBouton = "normal" | "petit";

interface BoutonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  libelle?: string;
  icone?: ComptaIconeNom;
  variante?: VarianteBouton;
  taille?: TailleBouton;
  // Pour un bouton inactif : la raison, montrée au survol.
  raison?: string;
}

export function Bouton({
  libelle,
  icone,
  variante = "primaire",
  taille = "normal",
  raison,
  className,
  ...props
}: BoutonProps) {
  // La classe passée par l'écran s'ajoute à celle de la brique, elle ne la
  // remplace pas (un bouton pleine largeur reste un bouton primaire).
  const classes = ["cbtn", `cbtn--${variante}`];
  if (taille === "petit") {
    classes.push("cbtn--petit");
  }
  if (className) {
    classes.push(className);
  }
  return (
    <button
      type="button"
      className={classes.join(" ")}
      disabled={variante === "inactif"}
      title={variante === "inactif" ? raison : undefined}
      {...props}
    >
      {icone && <ComptaIcone nom={icone} taille={15} />}
      {libelle}
    </button>
  );
}
